import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const CartAdd = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M11 9.45117H13V6.45117H16V4.45117H13V1.45117H11V4.45117H8V6.45117H11V9.45117ZM7 18.4512C5.9 18.4512 5.01 19.3512 5.01 20.4512C5.01 21.5512 5.9 22.4512 7 22.4512C8.1 22.4512 9 21.5512 9 20.4512C9 19.3512 8.1 18.4512 7 18.4512ZM17 18.4512C15.9 18.4512 15.01 19.3512 15.01 20.4512C15.01 21.5512 15.9 22.4512 17 22.4512C18.1 22.4512 19 21.5512 19 20.4512C19 19.3512 18.1 18.4512 17 18.4512ZM7.17 15.2012L7.2 15.0812L8.1 13.4512H15.55C16.3 13.4512 16.96 13.0412 17.3 12.4212L21.16 5.41117L19.42 4.45117H19.41L18.31 6.45117L15.55 11.4512H8.53L8.4 11.1812L6.16 6.45117L5.21 4.45117L4.27 2.45117H1V4.45117H3L6.6 12.0412L5.25 14.4912C5.09 14.7712 5 15.1012 5 15.4512C5 16.5512 5.9 17.4512 7 17.4512H19V15.4512H7.42C7.29 15.4512 7.17 15.3412 7.17 15.2012Z"
    />
  </svg>
);
